import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap, map } from 'rxjs';
import { UserPreferenceService } from '@core/services/user-preference/user-preference.service';
import { AuthService } from '@core/auth/services/auth.service';
import { environment } from '@env/environment';

export const rootAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const userpreferenceService = inject(UserPreferenceService);
  const router = inject(Router);
  const authUrl = environment.authUrl;

  return authService.isAuthenticated$.pipe(
    take(1),
    switchMap((isAuthenticated) => {
      if (!isAuthenticated) {
        const returnUrl = encodeURIComponent(window.location.origin + state.url);
        window.location.href = `${authUrl}forward?app=${environment.medeaseAppId}&returnUrl=${returnUrl}`;
        return [false];
      }

      return userpreferenceService.selectedOrg$.pipe(
        map((org) => {
          const orgType = org?.type || org?.orgType;
          if (orgType === 'root') {
            return true;
          }

          router.navigate(['/dashboard']);
          return false;
        })
      );
    })
  );
};
